export default __webpack_public_path__ + "static/media/mainBG.02473004.jpg";